/* Dolce Catene — Premium Rework: interatividade das sections custom.
   Reveal no scroll (.dc-reveal dentro de .dc-anim) + tabs (.dc-pillars).
   Degrada sem JS: conteudo fica visivel se o script nao rodar. */
(function () {
  var io;

  function setupReveal(root) {
    var els = (root || document).querySelectorAll('.dc-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (e) {
      var anim = e.closest('.dc-anim');
      if (anim) anim.classList.add('dc-anim-ready');
      io.observe(e);
    });
  }

  function setupTabs(root) {
    (root || document).querySelectorAll('.dc-pillars').forEach(function (p) {
      var tabs = p.querySelectorAll('[data-dc-tab]');
      var panels = p.querySelectorAll('[data-dc-panel]');
      if (!tabs.length) return;
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          t.setAttribute('aria-selected', 'true');
          var panel = p.querySelector('[data-dc-panel="' + t.getAttribute('data-dc-tab') + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  function setupBeforeAfter(root) {
    (root || document).querySelectorAll('[data-dc-ba]').forEach(function (ba) {
      if (ba.dataset.dcBaInit) return;
      ba.dataset.dcBaInit = '1';
      var dragging = false;
      function setX(clientX) {
        var r = ba.getBoundingClientRect();
        var pos = Math.max(2, Math.min(98, ((clientX - r.left) / r.width) * 100));
        ba.style.setProperty('--pos', pos + '%');
      }
      ba.addEventListener('pointerdown', function (e) { dragging = true; setX(e.clientX); try { ba.setPointerCapture(e.pointerId); } catch (x) {} });
      ba.addEventListener('pointermove', function (e) { if (dragging) setX(e.clientX); });
      window.addEventListener('pointerup', function () { dragging = false; });
      ba.style.setProperty('--pos', '50%');
    });
  }

  function setupClinicians(root) {
    (root || document).querySelectorAll('[data-dc-toggle]').forEach(function (btn) {
      if (btn.dataset.dcInit) return; btn.dataset.dcInit = '1';
      btn.addEventListener('click', function () {
        var p = btn.closest('.dc-cr__body').querySelector('[data-dc-text]');
        var open = p.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.hide : btn.dataset.show;
      });
    });
    (root || document).querySelectorAll('.dc-cr').forEach(function (cr) {
      var track = cr.querySelector('[data-dc-track]');
      var dotsWrap = cr.querySelector('[data-dc-dots]');
      if (!track || !dotsWrap || track.dataset.dcInit) return;
      track.dataset.dcInit = '1';
      var dots = dotsWrap.querySelectorAll('button');
      var cards = track.querySelectorAll('.dc-cr__card');
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = +d.dataset.i; if (cards[i]) cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });
      track.addEventListener('scroll', function () {
        var c = track.getBoundingClientRect().left + track.clientWidth / 2, best = 0, min = Infinity;
        cards.forEach(function (card, i) {
          var r = card.getBoundingClientRect(), dd = Math.abs((r.left + r.width / 2) - c);
          if (dd < min) { min = dd; best = i; }
        });
        dots.forEach(function (dt, i) { dt.classList.toggle('is-active', i === best); });
      }, { passive: true });
    });
  }

  function setupProofMore(root) {
    (root || document).querySelectorAll('[data-dc-proof-more]').forEach(function (btn) {
      if (btn.dataset.dcInit) return; btn.dataset.dcInit = '1';
      btn.addEventListener('click', function () {
        var dcp = btn.closest('.dc-proof');
        var grid = dcp && dcp.querySelector('[data-dc-proof-grid]');
        if (!grid) return;
        var collapsed = grid.classList.toggle('is-collapsed');
        btn.textContent = collapsed ? btn.dataset.show : btn.dataset.hide;
      });
    });
  }

  function setupExplorer(root) {
    (root || document).querySelectorAll('[data-dc-fx]').forEach(function (fx) {
      if (fx.dataset.dcInit) return; fx.dataset.dcInit = '1';
      var dots = fx.querySelectorAll('[data-fx]');
      var panels = fx.querySelectorAll('[data-fx-panel]');
      var navs = fx.querySelectorAll('[data-fx-nav]');
      function activate(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.dataset.fx === i); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.fxPanel === i); });
        navs.forEach(function (n) { n.classList.toggle('is-active', n.dataset.fxNav === i); });
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { activate(d.dataset.fx); }); });
      navs.forEach(function (n) { n.addEventListener('click', function () { activate(n.dataset.fxNav); }); });
    });
  }

  // --- Cámaras de compresión: secuencia distal -> proximal (hover + autoplay) ---
  function setupChambers(root) {
    (root || document).querySelectorAll('[data-dc-chambers]').forEach(function (wrap) {
      if (wrap.__dcInit) return; wrap.__dcInit = true;
      var zones = [].slice.call(wrap.querySelectorAll('[data-ch]'));
      var panels = [].slice.call(wrap.querySelectorAll('[data-ch-panel]'));
      var dots = [].slice.call(wrap.querySelectorAll('[data-ch-dot]'));
      if (!zones.length) return;
      var current = 0, timer = null, hovering = false;
      var autoplay = wrap.getAttribute('data-autoplay') === 'true';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(i, manual) {
        current = i;
        zones.forEach(function (z, k) { z.classList.toggle('is-active', k === i); z.classList.toggle('is-filled', k <= i); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (manual) restart();
      }
      function next() { show((current + 1) % zones.length); }
      function restart() { if (timer) clearInterval(timer); if (autoplay && !reduce) timer = setInterval(function () { if (!hovering) next(); }, 1600); }

      zones.forEach(function (z, i) {
        z.addEventListener('mouseenter', function () { hovering = true; show(i); });
        z.addEventListener('mouseleave', function () { hovering = false; });
        z.addEventListener('focus', function () { hovering = true; show(i); });
        z.addEventListener('click', function () { show(i, true); });
      });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i, true); }); });

      show(0);
      if (autoplay && !reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { restart(); } else if (timer) { clearInterval(timer); timer = null; } });
        }, { threshold: 0.3 }).observe(wrap);
      }
    });
  }

  // --- Timeline: rellena la línea según el scroll ---
  function setupTimeline(root) {
    (root || document).querySelectorAll('[data-dc-timeline]').forEach(function (tl) {
      if (tl.__dcInit) return; tl.__dcInit = true;
      var fill = tl.querySelector('[data-tl-fill]');
      var steps = [].slice.call(tl.querySelectorAll('[data-tl-step]'));
      if (!steps.length) return;
      if (!('IntersectionObserver' in window)) { steps.forEach(function (s) { s.classList.add('is-on'); }); if (fill) fill.style.setProperty('--p', '100%'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-on');
            var done = steps.filter(function (s) { return s.classList.contains('is-on'); }).length;
            if (fill) fill.style.setProperty('--p', (done / steps.length * 100) + '%');
          }
        });
      }, { threshold: 0.55 });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  function init(root) { setupReveal(root); setupTabs(root); setupBeforeAfter(root); setupClinicians(root); setupProofMore(root); setupExplorer(root); setupChambers(root); setupTimeline(root); }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  // editor de tema: re-inicializa ao carregar/editar uma section
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
